import React from 'react';

interface HighlightTextProps {
  text: string;
  search: string;
}

export const HighlightText: React.FC<HighlightTextProps> = ({ text, search }) => {
  if (!search) return <>{text}</>;

  const parts = text.split(new RegExp(`(${search})`, 'gi'));
  return (
    <span>
      {parts.map((part, i) =>
        part.toLowerCase() === search.toLowerCase() ? (
          <mark key={i}>{part}</mark>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </span>
  );
};
